import { Theme as V9Theme, webLightTheme } from "@fluentui/react-components";
import { PartialTheme as PartialV8Theme } from "../types";

/**
 * Helper function that creates v9 partial theme overrides from a v8 partial theme.
 * It uses the mapping we currently have for the Text colors.
 * The following Fluent documentation also has a recommended semantic mapping but it doesn't give us the direct 1-to-1 mapping that we need.
 * https://react.fluentui.dev/?path=/docs/concepts-migration-from-v8-color-mapping--docs
 * This function shall be cleaned up as part of this task: https://microsoft.visualstudio.com/DefaultCollection/OS/_workitems/edit/53498102
 */
export const getV9ThemeOverridesFromV8Theme = (theme: PartialV8Theme): Partial<V9Theme> => {
    return {
        colorNeutralForeground1: theme.palette.neutralPrimary ?? webLightTheme.colorNeutralForeground1,
        colorNeutralForeground2: theme.palette.neutralPrimary ?? webLightTheme.colorNeutralForeground2,
        colorNeutralForeground3: theme.palette.neutralSecondary ?? webLightTheme.colorNeutralForeground3,
        colorNeutralForeground4: theme.palette.neutralTertiary ?? webLightTheme.colorNeutralForeground4,
        colorBrandForeground1: theme.palette.themePrimary ?? webLightTheme.colorBrandForeground1,
        colorBrandForeground2: theme.palette.themeDarkAlt ?? webLightTheme.colorBrandForeground2,
        colorStatusSuccessForeground3: theme.semanticColors.messageWebSuccess ?? webLightTheme.colorStatusSuccessForeground3,
        colorStatusWarningForeground1: theme.semanticColors.cautionYellow ?? webLightTheme.colorStatusWarningForeground1,
        colorStatusDangerForeground1: theme.palette.redDark ?? webLightTheme.colorStatusDangerForeground1,
    };
};

export const getFluentV9ThemeFromV8Theme = (theme: PartialV8Theme): V9Theme => ({
    ...webLightTheme,
    ...getV9ThemeOverridesFromV8Theme(theme)
});
